<template>
  <ul class="tabs">
    <li class="tab thermodynamic" :class="{ active: tab == 'thermodynamic' }" @click="tab = 'thermodynamic'">收割热力</li>
    <li class="tab progression" :class="{ active: tab == 'progression' }" @click="tab = 'progression'">收割进度</li>
  </ul>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    value: {
      type: String,
      default: 'thermodynamic', // 收割热力:thermodynamic, 收割进度:progression
    },
  },
  data() {
    return {
      tab: this.value,
    };
  },
  watch: {
    value(val) {
      this.tab = val;
    },
    tab(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.tabs {
  list-style: none;
  margin: 0;
  padding: 0;
  user-select: none;
  .tab {
    width: vw(183);
    height: vh(62);
    text-align: center;
    text-indent: vw(-999);
    overflow: hidden;
    cursor: pointer;
    position: relative;
    &:hover {
      opacity: 0.9;
    }
    &.progression {
      background: url(../images/btn_map_jdt.png) no-repeat left top;
      background-size: 100% 100%;
      &.active {
        background-image: url(../images/btn_map_jdt_c.png);
        &:hover {
          opacity: 1;
          cursor: default;
        }
      }
      &:not(.active):active {
        left: 1px;
        top: 1px;
      }
    }
    &.thermodynamic {
      background: url(../images/btn_map_rlt.png) no-repeat left top;
      background-size: 100% 100%;
      &.active {
        background-image: url(../images/btn_map_rlt_c.png);
        &:hover {
          opacity: 1;
          cursor: default;
        }
      }
      &:not(.active):active {
        left: 1px;
        top: 1px;
      }
    }
  }
}
</style>
